import { useIntl } from 'react-intl'
import TextButton from 'LuxKit/Button/TextButton'
import LineFilterAltIcon from 'LuxKit/Icons/line/LineFilterAltIcon'
import { rem } from 'polished'
import * as React from 'react'
import styled from 'styled-components'
import clsx from 'clsx'
import LineMapIcon from 'LuxKit/Icons/line/LineMapIcon'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { useInView } from 'react-intersection-observer'
import noop from 'lib/function/noop'
import { connect } from 'react-redux'
import Heading from 'LuxKit/Typography/Heading'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

const MobileFilterBar = styled(CSSBreakpoint)`
  display: flex;
  transition: box-shadow 0.2s, background-color 0.2s, width 0.2s, margin-left 0.2s, padding 0.2s;
  box-shadow: none;
  width: 100%;
  margin-left: 0;
  padding: 0;
  position: sticky;
  top: 0;
  z-index: 1;
  gap: ${rem(8)};

  > * {
    flex-grow: 1;
  }

  &.lifted {
    background-color: ${props => props.theme.palette.neutral.default.eight};
    box-shadow: ${props => props.theme.shadow.bottom.small};
    margin-left: ${rem(-20)};
  }
`

const StyledTextButton = styled(TextButton)`
  padding: ${rem(12)} 0;
  height: auto;
`

const Wrapper = styled(VerticalSpacer)`
  display: flex;
  flex-direction: column;
  width: 100%;
`

interface Props {
  mapViewPath?: string
  listViewPath?: string
  onSortAndFilterClick?: () => void
  onViewSwitch?: () => void
  hasSortOptions?: boolean
  heading?: React.ReactNode
  showFilterIcon?: boolean
  isTours?: boolean
}

function MobileOfferListFilters(props: Props) {
  const {
    mapViewPath,
    onSortAndFilterClick,
    onViewSwitch = noop,
    hasSortOptions,
    heading,
    showFilterIcon = true,
    isTours = false,
  } = props

  const intl = useIntl()
  const [toLiftRef, liftInView] = useInView()
  const sortAndFilterLabel = intl.formatMessage({
    id: 'YuQeD_n-XZJLc6iWMlUt',
    defaultMessage: 'Sort & filter',
    description: 'Mobile button label to open sort and filter panel in the offer listing section',
  })
  const filtersLabel = intl.formatMessage({
    id: 'EUGMfS-0fW_pqpX7qDFo',
    defaultMessage: 'Filters',
    description: 'Mobile button label to open filters panel in the filters panel',
  })
  const mapViewLabel = intl.formatMessage({
    id: 'VWuA2c1CdPpQawu3yYkN',
    defaultMessage: 'Map view',
    description: 'Toggle button label to switch to map view of offers',
  })
  const sortAndFilterButtonText = hasSortOptions ? sortAndFilterLabel : filtersLabel

  return (
    <CSSBreakpoint max="mobile">
      <Wrapper gap={16}>
        { heading &&
          <Heading variant="heading2" align="start">
            {heading}
          </Heading>}
        {(mapViewPath || isTours) &&
          <MobileFilterBar max="mobile" className={clsx({ lifted: !liftInView })}>
            <>
              <StyledTextButton
                kind="secondary"
                variant="dark"
                startIcon={showFilterIcon ? <LineFilterAltIcon /> : undefined}
                onClick={onSortAndFilterClick}
                data-testid="sort-and-filter-button"
              >
                {sortAndFilterButtonText}
              </StyledTextButton>
              {mapViewPath &&
                <StyledTextButton
                  kind="secondary"
                  variant="dark"
                  to={mapViewPath}
                  startIcon={<LineMapIcon />}
                  onClick={onViewSwitch}
                >
                  {mapViewLabel}
                </StyledTextButton>}
            </>
          </MobileFilterBar>}
        <div ref={toLiftRef} />
      </Wrapper>
    </CSSBreakpoint>
  )
}

function mapStateToProps(state: App.State) {
  return {
    hasPopularHolidayTypes: state.destination.hotelPopularHolidayTypes.length > 0,
  }
}

export default connect(mapStateToProps)(MobileOfferListFilters)
